var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllusWaiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "waiting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.2232 10.0444L99.2118 10.0444C99.8873 10.0444 100.435 9.49683 100.435 8.82133V5.22321C100.435 4.54771 99.8873 4.0001 99.2118 4.0001L29.2232 4.0001C28.5477 4.0001 28.0001 4.54771 28.0001 5.22321V8.82133C28.0001 9.49683 28.5477 10.0444 29.2232 10.0444Z",
    fill: "url(#paint0_linear_2698_48553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M99.2184 117.956H29.2297C28.5542 117.956 28.0066 118.503 28.0066 119.179V122.777C28.0066 123.452 28.5542 124 29.2297 124H99.2184C99.8939 124 100.441 123.452 100.441 122.777V119.179C100.441 118.503 99.8939 117.956 99.2184 117.956Z",
    fill: "url(#paint1_linear_2698_48553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M79.4351 79.8642C70.6793 72.2603 66.5311 67.4779 66.5311 64.0027C66.5311 60.5276 70.6793 55.7387 79.4351 48.1412C88.191 40.5373 97.4322 34.2859 95.9308 10.0503H32.5042C31.0028 34.2859 40.2505 40.5373 48.9999 48.1412C57.7558 55.7452 61.904 60.5276 61.904 64.0027C61.904 67.4779 57.7558 72.2668 48.9999 79.8642C40.2441 87.4682 31.0028 93.7196 32.5042 117.955H95.9308C97.4322 93.7196 88.1845 87.4682 79.4351 79.8642Z",
    fill: "url(#paint2_linear_2698_48553)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 722",
    cx: 100.007,
    cy: 101.007,
    r: 3.00661,
    fill: "#B5D9ED"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 723",
    cx: 31.0066,
    cy: 86.0066,
    r: 3.00661,
    fill: "#9DF9DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 16",
    d: "M96.8911 50.7162L93.9089 60.4157L87 52.9833L96.8911 50.7162Z",
    fill: "#9DF9DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2698_48553",
    x1: 100,
    y1: 8.5,
    x2: 98.273,
    y2: 19.5166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2178FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2698_48553",
    x1: 28.4415,
    y1: 119.5,
    x2: 30.1686,
    y2: 108.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2178FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2698_48553",
    x1: 55.235,
    y1: 11.5705,
    x2: 85.5317,
    y2: 193.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusWaiting);
export default __webpack_public_path__ + "static/media/illus_waiting.bf6b4ed3547f689c9317fcad751e326e.svg";
export { ForwardRef as ReactComponent };